// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__euBWn","tab":"ProcedureTabs_tab__b-GKB"};